import React from "react";

export default function ARelative({ src, srcSet, alt, className }) {
	return <div className="a-image a-image--relative">
		<img src={src} srcSet={srcSet} alt={alt} className={` a-image--relative-image ${className}`} />
	</div>;
}
